import {ProfileContext} from './~context'

export const ProfileProvider = ProfileContext.Provider